import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GameContextType {
  reset: boolean;
  triggerReset: () => void;
  clearReset: () => void;
}

const GameContext = createContext<GameContextType | undefined>(undefined);

export function GameProvider({ children }: { children: ReactNode }) {
  const [reset, setReset] = useState(false);

  const triggerReset = () => setReset(true);
  const clearReset = () => setReset(false);

  return (
    <GameContext.Provider value={{ reset, triggerReset, clearReset }}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame(): GameContextType {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}
